<template>
  <p v-if="rawHTML" class="Text rawHTML" v-html="rawHTML" />
  <p v-else class="Text">
    <slot />
  </p>
</template>
<script>
export default {
  name: 'TText',
  props: ['rawHTML'], // used for optional raw-html rendering
};
</script>
<style scoped>
.Text {
  font: normal normal normal 16px/22px Lato;
  letter-spacing: 0.16px;
  color: #2b4047;
  margin-top: 2em;
  max-width: 63ch;
}
.rawHTML {
  white-space: pre-line;
}
@media (min-width: 768px) {
  .Text {
    font: normal normal normal 20px/24px Lato;
    letter-spacing: 0px;
    margin-left: 75px;
  }
}
</style>
